<template>
	<div>
		<v-dialog v-model="dialog" persistent max-width="570px" overlay-opacity="100" v-cloak>
			<v-card class="dialog-appointment">
				<v-card-title class="text-center">
					<img
							src="../assets/logo.png"
							alt="logo"
							class="logo"
					>
				</v-card-title>
				<v-card-text v-if="view === 'login'">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-form
										ref="formLogin"
										v-model="validLogin"
										lazy-validation>
									<v-text-field
											v-model="login.email"
											label="Email"
											:rules="emailRules"
											placeholder="Escribe tu email"
											color="primary"
											required></v-text-field>
									<v-text-field
											v-model="login.password"
											:rules="passwordRules"
											color="primary"
											label="Contraseña"
											placeholder="Escribe tu contraseña"
											type="password"
											@keyup.enter="singInSend"
											required></v-text-field>
									<div class="text-center login-actions">
										<v-btn color="primary" class="mt-5 mb-3" @click="singInSend">Iniciar sesión</v-btn>
										<br/>
										<v-btn color="primary darken-1"  class="mb-3" text small @click="openSingUp">Registrarme</v-btn>
										<br/>
										<v-btn color="primary darken-1" class="mb-3"  text small @click="openRecover">Olvidé mi contraseña</v-btn>
									</div>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-card-text v-if="view === 'singUp'">
					<h4 class="text-center">Registrarme</h4>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-form
										ref="formSingUp"
										v-model="validSingUp"
										lazy-validation>
									<v-text-field
											v-model="singUp.email"
											color="primary"
											:rules="emailRules"
											label="Email"
											placeholder="Escribe tu email"
											required></v-text-field>
									<v-text-field
											color="primary"
											v-model="singUp.password"
											:rules="passwordRules"
											label="Contraseña"
											placeholder="Escribe tu contraseña"
											type="password"
											required></v-text-field>
									<v-text-field
											v-model="singUp.confirm"
											color="primary"
											:rules="passwordRules"
											label="Confirma tu contraseña"
											placeholder="Confirma tu contraseña"
											type="password"
											required></v-text-field>
									<div class="terms-ctn">
										<v-checkbox v-model="terms" :rules="checkRules" style="display: inline-block;">
										</v-checkbox>
										<label class="termsLabel">
											<span @click="terms = !terms">Acepto los </span>
											<a href="https://rubenjungbluth.com/terminos-y-condiciones/" target="_blank">
												terminos y condiciones
											</a>
										</label>
									</div>
									<div class="text-center login-actions">
										<v-btn color="primary" @click="singUpSend">Registrarme</v-btn>
										<br/>
										<v-btn color="primary darken-1" text small @click="openLogin">Regresar a Inicio de sesión</v-btn>
									</div>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-card-text v-if="view === 'forgotPass'">
					<h4 class="text-center">Restablecer contraseña</h4>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-form
										ref="formRecover"
										v-model="validRecover"
										lazy-validation>
									<v-text-field
											v-model="recover.email"
											:rules="emailRules"
											color="primary"
											label="Email"
											placeholder="Ingresa tu email"
											type="email"
											required></v-text-field>

									<div class="text-center login-actions"><v-spacer></v-spacer>
										<v-btn color="primary" @click="recoverSend">Restablecer</v-btn>
										<br/>
										<v-btn color="primary darken-1" text small @click="openLogin">Regresar a Inicio de sesión</v-btn>
									</div>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>

				<v-card-text v-if="view === 'newPassword'">
					<h4 class="text-center">Restablecer contraseña</h4>
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-form
										ref="formNewPassword"
										v-model="validNewPassword"
										lazy-validation>
									<v-text-field
											v-model="recover.password"
											:rules="passwordRules"
											color="primary"
											label="Nueva contraseña"
											placeholder="Contraseña"
											type="password"
											required></v-text-field>

									<div class="text-center login-actions"><v-spacer></v-spacer>
										<v-btn color="primary" @click="changePassword">Restablecer</v-btn>
										<br/>
									</div>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
			<v-overlay :z-index="203" :value="overlay">
				<v-progress-circular indeterminate size="64"></v-progress-circular>
			</v-overlay>
		</v-dialog>
		<v-snackbar v-model="snackbar" :color="colorSnack" :timeout="10000">
			{{ textSnack }}
			<template v-slot:action="{ attrs }">
				<v-btn
						text
						dark
						v-bind="attrs"
						@click="snackbar = false">
					Ok
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>

  import axios from 'axios'

  export default {
    name: "Login.vue",
		props: ['dialog'],
    data() {
      return {
        idBase: '',
        view: 'login',
        terms: false,
        validLogin: true,
        validSingUp: true,
        validRecover: true,
        login: {
          email:'',
          password:''
        },
        singUp: {
          email:'',
          confirm:'',
          password:''
        },
        recover: {
          email:'',
        },
        emailRules: [
          function(v) { return !!v || 'Ingrese su email'},
          function(v) { return /.+@.+\..+/.test(v) || 'Ingrese un email valido'}
        ],
        passwordRules: [
          function(v) { return !!v || 'Ingrese su contraseña'}
        ],
        checkRules: [
          (v) => !!v || 'Acepte los terminos y condiciones'
        ],
        overlay: false,
        textSnack: '',
        snackbar: false,
        colorSnack: '',
        isLogged: false,
        validNewPassword: true,
      }
    },
    methods: {
      singInSend () {
        var _isValid = this.$refs.formLogin.validate()
        if (_isValid) {
          this.overlay = true
          axios.post('/login', {
            email: this.login.email,
            password: this.login.password
          }).then((response) => {
            if (response.data) {
							this.dialog = false
							localStorage.setItem('token', response.data.token)
							this.overlay = false
							this.colorSnack = 'success'
							this.textSnack = 'Bienvenido a RubenJungbluth.com'
							this.snackbar = true
							this.isLogged = true
              if (sessionStorage.getItem('url')) {
                location.href = sessionStorage.getItem('url')
                location.reload()
                sessionStorage.removeItem('url')
              } else {
                location.reload()
              }
						} else {
              this.overlay = false
              this.colorSnack = 'error'
              this.textSnack = 'Credenciales incorrectas - Acceso restringido'
							this.snackbar = true
							setTimeout(() => {
								window.location.href = 'https://rubenjungbluth.com'
							}, 2000)
						}
					}).catch(() => {
						this.overlay = false
						this.colorSnack = 'error'
						this.textSnack = 'Datos invalidos'
						this.snackbar = true
						console.log(this.dialog)
					})
        }
      },
      singUpSend () {
        var _isValid = this.$refs.formSingUp.validate()
				var data = {}
        let itsFromForm = localStorage.getItem('previousForm')
        if(_isValid) {
          if (itsFromForm) {
            let dia = document.querySelector('#nacimiento-dia').value
            dia = dia > 9 ? dia:'0'+dia
            let mes = document.querySelector('#nacimiento-mes').value
            mes = mes > 9 ? mes:'0'+mes
            let hora = document.querySelector('#nacimiento-hora').value
            hora = hora > 9 ? hora:'0'+hora
            let minuto = document.querySelector('#nacimiento-minuto').value
            minuto = minuto > 9 ? minuto:'0'+minuto
            let user_data = {}
            user_data.names =document.querySelector('#nombre').value
            user_data.surnames =document.querySelector('#apellido').value
            user_data.document =document.querySelector('#dni').value
            user_data.current_country =document.querySelector('#residencia').value
            user_data.current_place =document.querySelector('#residencia_ciudad').value
            user_data.birth_date = document.querySelector('#nacimiento-anio').value + '-' + mes + '-' + dia + ' ' + hora + ':' + minuto +':00'
            user_data.born_country =document.querySelector('#nacimiento-pais').value
            user_data.born_place =document.querySelector('#nacimiento-ciudad').value
            user_data.phone =document.querySelector('#celular').value
            data = {
              email: this.singUp.email,
              password: this.singUp.password,
              user_data: user_data
            }
          }
          else {
            data = {
              email: this.singUp.email,
              password: this.singUp.password,
            }
          }
          this.overlay = true
          axios.post('/registration', data).then(() => {
            // this.dialog = false
            if (window.form) {
              window.goSubmit = true
              window.form.submit()
            } else {
              this.overlay = false
              this.colorSnack = 'success'
              this.textSnack = 'Se ha registrado tu usuario con exito, ya puedes loguearte'
              this.snackbar = true
              this.view = 'login'
            }
          }).catch(() => {
            this.overlay = false
            this.colorSnack = 'error'
            this.textSnack = 'El mail ya se encuentra registrado'
            this.snackbar = true
          })
        }
      },
      recoverSend () {
        var _isValid = this.$refs.formRecover.validate()
        if (_isValid) {
          this.overlay = true
          axios.post('/forget', {email: this.recover.email}).then(() => {
            this.overlay = false
            this.dialog = false
            this.colorSnack = 'success'
            this.textSnack = 'Se ha enviado un enlace de recuperación a tu correo.'
            this.snackbar = true
          }).catch( () => {
            this.overlay = false
            this.colorSnack = 'error'
            this.textSnack = 'No se encuentra registrado el email.'
            this.snackbar = true
          })
        }
      },
      openLogin () {
        this.dialog = true
        this.view = 'login'
        this.$nextTick(() => {
          this.$refs.formLogin.reset()
        })
      },
      openSingUp () {
        this.dialog = true
        this.view = 'singUp'
        this.$nextTick(() => {
          this.$refs.formSingUp.reset()
        })
      },
      openRecover () {
        this.dialog = true
        this.view = 'forgotPass'
        this.$nextTick(() => {
          this.$refs.formRecover.reset()
        })
      },
      fillMail (email) {
        this.singUp = {}
        this.$nextTick(() => {
          this.singUp.email = email
        })
      },
      logOut () {
        localStorage.removeItem('token')
        this.isLogged = false
      },
      recoverPass() {
        if (location.search.indexOf('?token=') > -1) {
          this.overlay = true
          const token = location.search.replace('?token=','')
          axios.get(`/forget/verify/${token}`).then((data) => {
            this.recover.userId = data.data.user_id
            this.recover.token = data.data.token
            this.overlay = false
            this.dialog = true
            this.view = 'newPassword'
            this.$nextTick(() => {
              this.$refs.formNewPassword.reset()
            })
          }).catch(() => {
            this.overlay = false
            this.colorSnack = 'error'
            this.textSnack = 'El token ha expirado.'
            this.snackbar = true
          })
        }
      },
      changePassword () {
        var _isValid = this.$refs.formNewPassword.validate()
        if(_isValid) {
          this.overlay = true
          axios.post('/user/password/reset', {
            user_id: this.recover.userId,
            token: this.recover.token,
            password: this.recover.password
          }).then(() => {
            this.overlay = false
            this.dialog = false
            this.colorSnack = 'success'
            this.textSnack = 'Se ha cambiado su contraseña.'
            this.snackbar = true
            window.location.href = '/#/' // replace to home
          }).catch(() => {
            this.overlay = false
            this.colorSnack = 'error'
            this.textSnack = 'Ha ocurrido un error.'
            this.snackbar = true
          })
        }
      }
    },
    mounted () {
      window.openSingUpGlobal = (form, email) => {
        window.form = form
        this.openSingUp()
        this.fillMail(email)
      }
      this.isLogged = localStorage.getItem('token') ? true:false
      this.recoverPass()
    }
  }
</script>

<style lang="scss" scoped>
	.dialog-appointment {
		.logo {
			width: 75px;
			margin: 40px auto 5px;
			display: block;
		}
		.close-btn {
			position: absolute;
			top: 15px;
			right: 15px;
			background: #CBCBCB;
			border-radius: 50% !important;
			color: #fff;
			font-size: 15px;
			width: 30px;
			height: 30px;
		}
		.modal-text {
			margin-top: 20px;
			font-size: 18px;
			font-weight: 600;
			span {
				color: #2C8886;
			}
		}
		::v-deep .btn-continue {
			display: block;
			margin: 30px auto 10px;
		}
		.ctn-img {
			margin-top: 40px;
			img {
				width: 75px;
			}
		}
	}

	#navegationComponent input:focus:required:invalid{
		border-bottom: 0;
		border-color: auto !important;
	}
	#navegationComponent .logo {
		display: inline-block;
		width: 85px;
		margin: 20px auto 15px auto;
	}
	#navegationComponent .v-label {
		left: -25px !important;
		min-width: 200px;
	}

	#navegationComponent .close-btn {
		position: absolute;
		top: 14px;
		right: 9px;
	}

	#navegationComponent .login-actions {
		margin-top: 10px;
	}

	#navegationComponent .login-actions button {
		margin-top: 12px;
	}


	#mainNav {
		z-index: 30;
	}

	.v-application .list-principal a {
		color: #656565;
	}
	.overlay-menu, #sidebar-wrapper{
		z-index: 99;
	}
	.terms-ctn {
		position: relative;
		width: 100%;
		margin-top: 4px;
	}
	.terms-ctn .v-input {
		margin-top: 0;
		width: 100%;
	}
	.termsLabel {
		vertical-align: middle;
		margin-top: -2px;
		position: absolute;
		top: 8px;
		left: 29px;
	}

	.v-btn {
		text-transform: none;
		letter-spacing: 0 !important;
		text-transform: none !important;
	}
	.v-btn span{
		font-weight: 400;
	}
	::v-deep .v-dialog {
		border-radius: 16px
	}
	.sub-menu {
		text-align: left;
	}
	.login-actions {
		padding-top: 17px;
	}
</style>
